// antd v5 renders its date panels through rc-picker, which calls weekday(),
// week() and localeData() on whatever Dayjs value we hand a <DatePicker />.
// rc-picker installs those plugins on its own copy of dayjs, and this project
// resolves a second copy (node_modules/dayjs) for application code, so a value
// built with our dayjs reaches the panel without them and opening the picker
// throws "clone.weekday is not a function".
//
// Extending our copy with the same plugins keeps both in sync. Imported once
// for its side effects from src/index.js.
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

export default dayjs;
